import { sizeOptionClassification } from '../Constants/sizeOptionClassification';
import { useSelector } from 'react-redux';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import { fetchItems, setSelectedComponentGroup } from '../Reducers/Configurator/Actions';
import {
  fetchConfiguration,
  setLoadIdentifier,
  selectOptionclassification,
} from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Actions';

const useCustomOptionClassifications = () => {
  const isPavillon = useSelector((state) =>
    state.configurator.configuration?.item?.identifier?.toLowerCase().includes('pavillon')
  );
  const translatedSizeOptionClassification = useSelector((state) => {
    const result = state.configurator.sizeOptionClassification || sizeOptionClassification;
    return {
      ...result,
      title: t(result.title),
    };
  });
  const selectedOptionClassification = useSelector((state) =>
    state.configurator.selectedoptionclassification.identifier === sizeOptionClassification.identifier
      ? translatedSizeOptionClassification
      : state.configurator.selectedComponentGroup || state.configurator.selectedoptionclassification
  );
  const options = useSelector((state) =>
    state.configurator.selectedoptionclassification.identifier === sizeOptionClassification.identifier
      ? state.configurator.itemOptions
      : state.configurator.options
  );
  const componentGroups = useSelector((state) => state.configurator.configuration.information?.components);
  const optionclassifications = useSelector((state) =>
    isPavillon
      ? [translatedSizeOptionClassification, ...state.configurator.filteredOptionclassifications]
      : componentGroups || state.configurator.filteredOptionclassifications
  );
  const selectedComponentGroup = useSelector((state) => state.configurator.selectedComponentGroup);
  const componentGroupComponents = selectedComponentGroup?.components;

  const onSelectOptionClassification =
    (dispatchAction, onOptionClassificationSelect, selectOptionClassification) => (optionClassification) => {
      if (optionClassification.identifier === sizeOptionClassification.identifier) {
        return onOptionClassificationSelect(dispatchAction, optionClassification, () => {
          selectOptionClassification(dispatchAction, optionClassification, false, true);
          dispatchAction(fetchItems());
        });
      }
      if (componentGroups?.some(({ identifier }) => optionClassification.identifier === identifier)) {
        selectOptionClassification(dispatchAction, optionClassification, false, true);
        return dispatchAction(setSelectedComponentGroup(optionClassification));
      }
      return onOptionClassificationSelect(dispatchAction, optionClassification, selectOptionClassification);
    };

  const onSelectOption = (dispatchAction, selectOption) => (option) => {
    return dispatchAction((dispatch, getState) => {
      if (componentGroupComponents) {
        // find container component
        const component = componentGroupComponents.find(({ selectableOptions }) =>
          selectableOptions.some(
            ({ identifier, options }) =>
              identifier === option.identifier ||
              options?.some(({ identifier }) => identifier === option.identifier)
          )
        );
        component?.identifier && dispatch(selectOptionclassification(component, false, true));
      }
      if (option.options) {
        // if the selected option has child options use the first one of them
        option = option.options[0];
      }
      if (
        getState().configurator.selectedoptionclassification.identifier ===
        sizeOptionClassification.identifier
      ) {
        dispatch(setLoadIdentifier(option.identifier));
        dispatch(fetchConfiguration(option.identifier));
      } else {
        return selectOption(dispatchAction, option);
      }
    });
  };

  return {
    optionclassifications,
    selectedOptionClassification,
    options,
    onSelectOptionClassification,
    onSelectOption,
    componentGroupComponents,
  };
};

export default useCustomOptionClassifications;
